<template>
    <div class="container-fluid">
        <!-- breadbrumb -->
        <app-breadcrumb pageTitle="Items" subTitle="Manage Item"></app-breadcrumb>

        <!-- Alert Messages -->
        <dl v-if="msg !== ''" class="row mt-3 mb-n3">
            <dd class="col-12">
                <div :class="`alert alert-${color} text-center mb-4 p-1`" role="alert">
                    <i class="fas fa-exclamation-circle"></i> {{ msg }}
                </div>
            </dd>
        </dl>

        <template v-if="listedItem">
            <!-- display -->
            <div class="row">
                <div class="col-sm-3 col-12">
                    <router-link :to="{ name: 'listItem', params: { id: listedItem._id} }">
                        <img :src="mainItemPhoto(listedItem.photos)" class="card-img" :alt="`${listedItem.title} - aNewItem`">
                    </router-link>
                </div>
                <div class="col-sm-9 col-12">
                    <h5 class="text-dark-gren mt-3">{{listedItem.title | capitalize}}</h5>
                    <hr>
                    <p>
                        Marked as Sold: 
                        <strong v-if="listedItem.sold" class="text-dark-green">YES</strong>
                        <strong v-else class="text-danger">NO</strong>,
                        Posted: <strong class="text-dark-green">{{listedItem.joined | postedTimeAgo}}</strong>, 
                        Price: <strong class="text-dark-green text-uppercase">{{listedItem.currency}} {{listedItem.price | money}}</strong>
                    </p>
                    <p>
                        Price is: 
                        <strong v-if="listedItem.firmPrice" class="text-danger">Non-negotiable</strong>
                        <strong v-else class="text-dark-green">Negotiable</strong>,
                        Item is for donation:  
                        <strong v-if="listedItem.donation" class="text-dark-green">YES</strong>
                        <strong v-else class="text-danger">NO</strong>
                    </p>
                    <p>
                        Category: <strong class="text-dark-green text-capitalize">{{listedItem.category}}</strong>, 
                        Condition: <strong class="text-dark-green text-capitalize">{{listedItem.condition}}</strong>
                    </p>
                    <p v-if="listedItem.sold">
                        Sold Price: <strong class="text-dark-green text-uppercase">
                            {{listedItem.currency}} {{listedItem.soldPrice | money}}
                        </strong>,
                        Sold Time: <strong class="text-dark-green">{{listedItem.soldTime | moment("MMM D YYYY hh:mm A")}}</strong>
                    </p>
                    <p v-if="listedItem.onSale">
                        On-Sale: <strong class="text-dark-green">YES</strong>, 
                        On-Sale Price: <strong class="text-dark-green text-uppercase">
                            {{listedItem.currency}} {{listedItem.onSalePrice | money}}
                        </strong>
                    </p>
                    <hr>
                    <p>{{listedItem.description | capitalize}}</p>
                    <div class="row">
                        <div v-if="!listedItem.sold" class="col-12">
                            <div class="row">
                                <div class="col-md-3 col-6 my-1">
                                    <router-link :to="{ name: 'modify-item', params: { id: listedItem._id } }">
                                        <span class="btn btn-block btn-dark btn-sm mr-2"><i class="far fa-edit"></i> Edit</span>
                                    </router-link>
                                </div>
                                <div class="col-md-3 col-6 my-1">
                                    <button @click="removeItemFxn" class="loadn btn btn-block btn-danger btn-sm"><i class="fas fa-trash-alt"></i> Delete</button>
                                </div>
                                <div class="col-md-3 col-6 my-1">
                                    <button @click="showPromotion = true" class="btn btn-block btn-warning btn-sm"><i class="fas fa-fire"></i> Promote</button>
                                </div>
                                <div class="col-md-3 col-6 my-1">
                                    <button @click="showMarkAsSold = true" class="btn btn-block btn-dark-green btn-sm"><i class="fas fa-wallet"></i> Mark as Sold</button>
                                </div>
                                <div class="col-md-12 col-12 my-2 text-center">
                                    <router-link :to="{ name: 'listItem', params: { id: listedItem._id} }" class="btn btn-block btn-secondary btn-sm">
                                        <i class="fas fa-globe"></i> View as Buyer
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <div v-else class="col-12">
                            <button class="btn btn-warning btn-sm">
                                <span v-if="listedItem.donation">ITEM DONATED</span>
                                <span v-else>ITEM SOLD</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div> 

            <!-- item stats display -->
            <app-item-stats :itemId="listedItem._id"></app-item-stats>           
        </template>

        <!-- show promotions -->
        <app-promotions :key="forceReloadKey" v-if="showPromotion" :itemId="listedItem._id"></app-promotions>

        <!-- show mark item as sold -->
        <app-mark-as-sold v-if="showMarkAsSold" :itemId="listedItem._id"></app-mark-as-sold>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { eventBus } from '@/main'
import { appendImgHostUrl } from '@/store/dry'

import MarkAsSold from '@/components/user/pages/sellingParts/MarkAsSold.vue'
import Promotions from '@/components/user/shared/Promotions.vue'
import Breadcrumb from '../../shared/Breadcrumb.vue'
import LayoutShop from '@/layouts/Shop.vue'
import ItemStats from './ItemStats.vue'

export default {
    data() {
        return {
            photoHolder: require('../../../../../public/img/web/anewitem-noimage.jpg'),
            showMarkAsSold: false,
            showPromotion: false,
            forceReloadKey: 0,
            msg: '',
            color: 'danger',
        }
    },
    methods: {
        ...mapActions(['listPostedItem', 'modifyItemObj', 'removeItem']),
        updatePage(newItemId){
            this.listPostedItem(newItemId).then(() => {}).catch((e) => {})
        },
        mainItemPhoto(itemPhotos) {
            if(itemPhotos){
                let src = ""
                for(let x=0; x < itemPhotos.length; x++){
                    if(itemPhotos[x].main){
                        src = appendImgHostUrl(itemPhotos[x].thumbPath)
                    }
                }
                if(src !== ""){
                    return src
                }
                return this.photoHolder
            }
            return this.photoHolder
        },
        removeItemFxn() {
            if(this.listedItem){
                this.color = "danger"
                let itemObj = {
                    itemId: this.listedItem._id,
                    userId: this.user._id
                }
                // vuejs-dialog usage for pop up confirmations
                // https://github.com/Godofbrowser/vuejs-dialog
                let message = "<center>This item will be permanently deleted! Do you want to proceed ?</center>";
                let options = {
                    html: true, 
                    okText: 'Yes, Proceed',
                    cancelText: 'Cancel',
                    animation: 'bounce', // Available: "zoom", "bounce", "fade"
                }
                this.$dialog.confirm(message, options)
                .then((dialog) => {
                    this.removeItem(itemObj)
                    .then((data) => {
                        this.color = !data.error ? "success" : "danger",
                        this.msg = data.msg
                        // redirect back to shop items page
                        if(!data.error){
                            this.$router.push({
                                name: 'items'
                            }).catch((e) => {})
                        }
                    })
                    .catch((e) => {})
                })
                .catch((e) => {})
            }
        },
    },
    computed: {
        ...mapGetters(['user', 'postedItem']),
        listedItem() {
            if(this.postedItem && this.postedItem !== null){
                return this.postedItem
            }else{
                return false
            }
        },
    },
    components: {
        appBreadcrumb: Breadcrumb,
        appMarkAsSold: MarkAsSold,
        appPromotions: Promotions,
        appItemStats: ItemStats
    },
    watch: {
        $route() {
            this.updatePage(this.$route.params.id)
        }
    },
    created() {
        this.updatePage(this.$route.params.id)
        eventBus.$on('hideGhostMode', (value) => {
            this.showMarkAsSold = value;
            this.showPromotion = value;
        }),
        this.$emit('update:layout', LayoutShop);
    }
}
</script>